import React from "react";
import userRollData from "../../js/userRollData";
import UserRollCom from "../../components/UserRollCom";
import { Newlogo } from "../../components";
const UserRoll = () => {
  return (
    <div className="bg-primary xs:pb-5 sm:pb-5 lg:pb-14 scroll-container h-screen">
      <div className="lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <div className="xs:py-5 sm:py-6 lg:py-10">
          <div className="flex justify-center items-center">
            <Newlogo />
          </div>
          <div className="flex justify-center items-center flex-col">
            <div className="relative w-full text-center pt-5 sm:pt-8">
              <h1 className="uppercase text-secondary font-unboundedBold xs:text-sm lg:text-3xl 2xl:text-[45px] lg:leading-tight ">
                I Want to{" "}
                <span className="bg-orangeCrayola rounded-full lg:px-2 xs:px-1 sm:px-1 text-[#1C3092] lg:mr-1">
                  Upgrade
                </span>
                as
              </h1>
            </div>
            <p className="text-secondary lg:pt-5 font-montserratMedium text-sm sm:text-base">
              Select One Option
            </p>
          </div>
        </div>
        <div className="sm:w-[90%] lg:w-[80%] 2xl-wide:w-[70%] 3xl:w-[70%] m-auto">
          <div className="flex justify-center xs:gap-4 sm:gap-5 lg:gap-8 items-center flex-wrap">
            {userRollData?.map((value, index) => (
              <div key={index}>
                <UserRollCom
                  comingSoon={value?.comingSoon}
                  icon={value?.icon}
                  title={value?.title}
                  bgColor={value?.bgColor}
                  to={value?.to}
                  iconsClass={"w-[25%]"}
                  themeclass={
                    "xs:w-52 xs:h-48 sm:w-64 sm:h-52 lg:w-80 rounded-3xl flex justify-center items-center flex-col lg:h-72 cursor-pointer transition-all duration-300 transform hover:scale-105 hover:shadow-md"
                  }
                  textclass={
                    "text-secondary text-center uppercase font-montserratSemiBold xs:text-sm lg:text-xl xl:text-[28px]"
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserRoll;
